import { SocieteComposantSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteComposantModel: SelectorModel = {
  name: 'societeComposants',
  getSelector: SocieteComposantSelectors.selectAllSocieteComposantsDictionary,
  isReady: SocieteComposantSelectors.selectIsReadySocieteComposant
};
